<!-- 车场区域信息变更上报 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                    "dataList":[
                        {
                            "parkingAreaSeq":41,
                            "channelList":[
                                {
                                    "channelName":"123",
                                    "channelId":89
                                }
                            ],
                            "operateMode":1,
                            "childAreaList":[
                                {
                                    "parkingAreaSeq":54,
                                    "channelList":[
                                        {
                                            "channelName":"ahaoTest入口",
                                            "channelId":97
                                        }
                                    ],
                                    "operateMode":1,
                                    "childAreaList":[

                                    ],
                                    "enable":1,
                                    "parkingAreaName":"ahaotestin1"
                                }
                            ],
                            "enable":1,
                            "parkingAreaName":"190区域"
                        }
                    ],
                    "updateTime":"20230711100635",
                    "parkCode":"2KKN885S"
                },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场车场区域信息变更到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportChargeParkingArea",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'updateTime', info2: '是', info3: 'String', info4: '更新时间(yyyMMddHHmmss)' },
                        { info1: 'dataList', info2: '是', info3: 'JSONArray', info4: '一级区域' }
                        ]
                },{
                    titleName: 'dataList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingAreaSeq', info2: '是', info3: 'String', info4: '区域编号' },
                        { info1: 'operateMode', info2: '是', info3: 'Integer', info4: '数据状态 0:新增 1:更新 2:删除' },
                        { info1: 'enable', info2: '是', info3: 'Integer', info4: '区域状态 1启用 0禁用,vems默认启用状态' },
                        { info1: 'parkingAreaName', info2: '是', info3: 'String', info4: '区域名称' },
                        { info1: 'channelList', info2: '否', info3: 'JSONArray', info4: '通道' },
                        { info1: 'childAreaList', info2: '否', info3: 'JSONArray', info4: '子区域（可能存在多级）' },
                    ]
                },{
                    titleName: 'channelList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'channelName', info2: '是', info3: 'String', info4: '通道名称' },
                        { info1: 'channelId', info2: '是', info3: 'Integer', info4: '通道id' },
                       
                    ]
                },{
                    titleName: 'childAreaList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingAreaSeq', info2: '是', info3: 'String', info4: '区域编号' },
                        { info1: 'operateMode', info2: '是', info3: 'Integer', info4: '数据状态 0:新增 1:更新 2:删除' },
                        { info1: 'enable', info2: '是', info3: 'Integer', info4: '区域状态 1启用 0禁用,vems默认启用状态' },
                        { info1: 'parkingAreaName', info2: '是', info3: 'String', info4: '区域名称' },
                        { info1: 'channelList', info2: '否', info3: 'JSONArray', info4: '通道' },
                        { info1: 'childAreaList', info2: '否', info3: 'JSONArray', info4: '子区域' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: []
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportChargeParkingArea.vue